import {GET_USER_POINTS as SOCKET_GET_USER_POINTS} from '../../events/DashboardToServer'
import {CHANGE_USER_POINTS as SOCKET_CHANGE_USER_POINTS} from '../../events/DashboardToServer'
import { ANSWER_PROCESSED, USER_ANSWERS_RECEIVED } from '../userAnswer/actions';

const GET_USER_POINTS = 'GET_USER_POINTS'
const RECEIVE_USER_POINTS = 'RECEIVE_USER_POINTS'
const CHANGE_USER_POINTS = 'CHANGE_USER_POINTS'
export const CHANGED_USER_POINTS = 'CHANGED_USER_POINTS'

export const userPoints = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_USER_POINTS:
             return {
                ...state,
                [action.user_id]: action.user_points
             }
            
        case CHANGED_USER_POINTS:
            return {
                ...state,
                [action.user_id]: action.balance
             }

         case ANSWER_PROCESSED:
            return {
                ...state,
                [action.user_answer.user_id]: action.user_answer.new_balance
             }

        case USER_ANSWERS_RECEIVED:
            var answers = action.userAnswers
            var balance = action.balance;
            for (var i = 0; i< answers.length; i++){
                var ans = answers[i]
                    if (ans.new_balance && ans.is_notified !== 0)
                        balance = ans.new_balance;
                    else {
                        if (ans.bet){
                            balance = ans.old_balance - ans.bet;
                        }else{
                             balance = ans.old_balance;
                        }
                        break;
                    }
                }
            if (!balance) balance = action.balance;
            return {
                ...state,
                [action.user_id]: balance
            }
             
        default:
            return state
    }
}

export const getUserPoints = (socket, user_id) => {
    socket.emit(SOCKET_GET_USER_POINTS, user_id)
    return { type: GET_USER_POINTS, user_id }
}

export const receiveUserPoints = (user_id, user_points) => {
    return { type: RECEIVE_USER_POINTS, user_id, user_points }
}

export const changeUserPoints = (socket, user_id, points, reason) => {
    socket.emit(SOCKET_CHANGE_USER_POINTS, user_id, points, reason)
    return { type: CHANGE_USER_POINTS, user_id, points }
}

export const changedUserPoints = (user_id, balance) => {
   return { type: CHANGED_USER_POINTS, user_id, balance }
}



// WEBPACK FOOTER //
// ./src/reducers/userPoints/index.js